import { render, staticRenderFns } from "./card-table.vue?vue&type=template&id=ac24a380&scoped=true&"
import script from "./card-table.vue?vue&type=script&lang=js&"
export * from "./card-table.vue?vue&type=script&lang=js&"
import style0 from "./card-table.vue?vue&type=style&index=0&id=ac24a380&prod&lang=scss&scoped=true&"
import style1 from "./card-table.vue?vue&type=style&index=1&id=ac24a380&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.0_enyi6aqizbgycdmugvkasw26ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac24a380",
  null
  
)

export default component.exports